/**
 * A global namespace for `error` event.
 */
const errorEvent = "error";
export default errorEvent;
